// メッセージMap
export const MessageMap = {
    "register_mail_address": "登録メールアドレス",
};